import { Node } from 'reactflow';

// Node type definitions and styling
export const nodeTypeConfig = {
  teacher: {
    background: '#E6F9F9', 
    borderColor: '#00CED1', 
    label: 'Teacher'
  },
  learner: {
    background: '#FFE6E6', 
    borderColor: '#FF0000', 
    borderWidth: 3,
    label: 'Learner'
  },
  peer: {
    background: '#F0FFE8', 
    borderColor: '#7AC943',
    label: 'Peer'
  }
};

// Base node styles
export const baseNodeStyles = {
  border: '2px solid',
  borderRadius: '8px',
  padding: '12px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  transition: 'all 0.3s ease',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'grab',
  width: 100,
  height: 40,
  // minWidth: 150,
  // minHeight: 80,
};

// Handle styles
export const handleStyles = {
  // background: '#555',
  // width: '6px',
  // height: '6px',
  // border: '1.5px solid white',
  // borderRadius: '50%',
  opacity: 0,
  // pointerEvents: 'none',
};

// Label styles
export const labelStyles = {
  margin: 0,
  color: '#333',
  fontSize: '0.9rem',
  fontWeight: 600,
  textAlign: 'center' as const,
  lineHeight: 1.2,
  whiteSpace: 'pre-line' as const,
};

export const nodes: Node[] = [
  // Teacher Column
  {
    id: 'teacher-concepts',
    type: 'frameworkNode',
    position: { x: 100, y: 100 },
    data: {
      label: 'Teacher\nconcepts',
      type: 'teacher'
    },
  },
  {
    id: 'learning-environment',
    type: 'frameworkNode',
    position: { x: 100, y: 300 },
    data: {
      label: 'Learning\nenvironment',
      type: 'teacher'
    },
  },
  
  // Learning Column
  {
    id: 'learner-concepts',
    type: 'frameworkNode',
    position: { x: 400, y: 100 },
    data: {
      label: 'Learner\nconcepts',
      type: 'learner'
    },
  },
  {
    id: 'learner-practice',
    type: 'frameworkNode',
    position: { x: 400, y: 300 },
    data: {
      label: 'Learner\npractice',
      type: 'learner'
    },
  },
  
  // Peer Column
  {
    id: 'peer-concepts',
    type: 'frameworkNode',
    position: { x: 700, y: 100 },
    data: {
      label: 'Peer\nconcepts',
      type: 'peer'
    },
  },
  {
    id: 'peer-practice',
    type: 'frameworkNode',
    position: { x: 700, y: 300 },
    data: {
      label: 'Peer\npractice',
      type: 'peer'
    },
  },
];
